module.exports = __webpack_public_path__ + "media/images/story/typo/aboutNatural-9e50f0a917eda101a322bf68db9cb619.svg";